import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, MessageCircle, Twitter } from 'lucide-react';
import SafeImage from './SafeImage';
import { useAuth } from '../context/AuthContext';
import { CONTACT_LINKS } from '../config/siteContact';

export default function Footer() {
  const { isAuthed } = useAuth();

  return (
    <footer className="relative z-10 mt-20 border-t border-orange-500/15">
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 flex items-center justify-center rounded-sm border border-orange-500/60 bg-orange-500/10 overflow-hidden">
              <SafeImage src="/valorex-logo.png" alt="ValoRex" className="w-8 h-8 object-contain" fallbackClassName="w-8 h-8" />
            </div>
            <div className="font-mono-display text-lg font-bold">
              <span className="neon-orange">VALO</span><span className="neon-cyan">REX</span>
            </div>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed">
            Preview, share, and manage your Valorant accounts in a secure neon-grade vault built for operators.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold tracking-wider uppercase text-orange-300 mb-3">Getting Started</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/pricing" className="hover:text-cyan-300">Pricing</Link></li>
            <li><Link to="/dashboard" className="hover:text-cyan-300">Dashboard</Link></li>
            {!isAuthed && <li><Link to="/auth/register" className="hover:text-cyan-300">Get Started</Link></li>}
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold tracking-wider uppercase text-orange-300 mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/about" className="hover:text-cyan-300">About</Link></li>
            <li><Link to="/terms-of-service" className="hover:text-cyan-300">Terms of Service</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-cyan-300">Privacy Policy</Link></li>
            <li><Link to="/contact" className="hover:text-cyan-300">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold tracking-wider uppercase text-orange-300 mb-3">Community</h4>
          <div className="flex gap-3">
            <a
              href={CONTACT_LINKS.discordUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Join ValoRex on Discord"
              className="w-9 h-9 grid place-items-center border border-cyan-400/30 rounded hover:border-cyan-300/80 hover:bg-cyan-400/5 transition-colors"
            >
              <MessageCircle className="w-4 h-4 text-cyan-300" />
            </a>
            <a
              href="#"
              aria-label="ValoRex on Facebook"
              className="hidden w-9 h-9 place-items-center border border-cyan-400/30 rounded hover:border-cyan-300/80 hover:bg-cyan-400/5 transition-colors"
            >
              <Facebook className="w-4 h-4 text-cyan-300" />
            </a>
            <a
              href="#"
              aria-label="ValoRex on X"
              className="hidden w-9 h-9 place-items-center border border-cyan-400/30 rounded hover:border-cyan-300/80 hover:bg-cyan-400/5 transition-colors"
            >
              <Twitter className="w-4 h-4 text-cyan-300" />
            </a>
          </div>
          <p className="text-xs text-zinc-500 mt-4">Not affiliated with Riot Games.<br/>Valorant is a trademark of Riot Games, Inc.</p>
        </div>
      </div>
      <div className="border-t border-orange-500/10 py-4">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-zinc-500">
          <span>&copy; {new Date().getFullYear()} VALOREX // All rights reserved</span>
          <span className="font-mono-display tracking-widest">SYSTEM STATUS: <span className="text-cyan-300">ONLINE</span></span>
        </div>
      </div>
    </footer>
  );
}
